<template>
  <div class="vTable-box" :class="styleClassName">
    <div class="vTable-title">
      <el-table style="width: 100%" :border="styleType==='border'" :data="tableData">
        <el-table-column
          v-if="hasIndex"
          :label="indexName"
          type="index"
          width="50"
        >
        </el-table-column>
        <el-table-column
          v-for="item in tableColums"
          :key="item.code"
          :label="item.name"
          :prop="item.code"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :min-width="item.minWidth"
          :width="item.width"
          :align="item.align"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="vTable-content">
      <component :is="isScroll?'vscroll':'tem'" :data="tableData" :class-option="defaultOption" :style="{'height': contentHeight}">
        <el-table
          :data="tableData"
          style="width: 100%"
          :span-method="objectSpanMethod"
          :border="styleType==='border'"
          :show-header="false"
        >
          <el-table-column
            v-if="hasIndex"
            type="index"
            :label="indexName"
            width="50"
          >
            <template v-slot="{row, column, $index}">
              <div :class="indexStyle($index + 1)">{{ indexVal ? indexVal(row, column, $index) : ++$index }}</div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item in tableColums"
            :key="item.code"
            :label="item.name"
            :prop="item.code"
            :show-overflow-tooltip="item.showOverflowTooltip"
            :width="item.width"
            :min-width="item.minWidth"
            :align="item.align"
          >
            <template v-slot="{row, column, $index}">
              <slot
                v-if="$scopedSlots[column.property]"
                :name="column.property"
                :row="row"
                :column="column"
                :$index="$index"
              ></slot>
              <div v-else>{{ item.render ? item.render(row, column, $index) : row[column.property] }}</div>
            </template>
          </el-table-column>
        </el-table>
      </component>
    </div>
  </div>
</template>
<script lang="jsx">
import vueSeamlessScroll from 'vue-seamless-scroll'
import vscroll from './components/scroll'
import tem from './components/tem'
export default {
  name: 'vue-table',
  components: {vueSeamlessScroll, vscroll, tem},
  props: {
    hasIndex: {
      type: Boolean,
      default: false
    },
    hasIndexStyle: {
      type: Boolean,
      default: false
    },
    indexName: {
      type: String,
      default: '序号'
    },
    tableData: {
      type: Array,
      default: () => ([])
    },
    tableColums: {
      type: Array,
      default: () => ([])
    },
    rowSpanCodeList: {
      type: Array,
      default: () => ([])
    },
    columnSpanCodeList: {
      type: Array,
      default: () => ([])
    },
    styleType: {
      type: String,
      default: 'line'
    },
    isScroll: {
      type: Boolean,
      default: false,
    },
    scrollOptions: {
      type: Object,
      default: () => ({})
    },
    indexVal: {

    }
  },
  data() {
    return {
      contentHeight: '200px'
    }
  },
  computed: {
    defaultOption() {
      const defaultOpt = {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
      return {...defaultOpt, ...this.scrollOptions}
    },
    indexStyle() {
      return index => {
        if (!this.hasIndexStyle) {
          return ''
        }
        switch (index) {
          case 1:
            return 'table-index table-index1'
            break;
          case 2:
            return 'table-index table-index2'
            break;
          case 3:
            return 'table-index table-index3'
            break;
          default:
            return 'table-index'
            break;
        }
      }
    },
    styleClassName() {
      return `vTable-style-${this.styleType}`
    },
  },
  mounted() {
    const dom = document.querySelector('.vTable-content')
    let height = 200
    if (dom) {
      height = dom.offsetHeight
    }
    this.contentHeight = height + 'px'
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const { rowSpanCodeList, columnSpanCodeList } = this
      if (
        (!rowSpanCodeList || !rowSpanCodeList.length) &&
        (!columnSpanCodeList || !columnSpanCodeList.length)
      ) {
        return false
      }
      let code = column.property // 当前单元格code
      let colspanCount = 1 // 合并列数
      let rowspanCount = 1 // 合并行数
      // 合并行处理
      if (rowSpanCodeList.includes(code)) {
        rowspanCount = this.getRowspanCount(rowIndex, code)
      }
      // 合并列处理
      columnSpanCodeList.map(item => {
        if (item.includes(code)) {
          colspanCount = this.getColspanCount(rowIndex, code, item)
        }
      })
      return {
        rowspan: rowspanCount,
        colspan: colspanCount,
      }
    },
    // 计算合并行的数量
    getRowspanCount(rowIndex, code) {
      const { tableData } = this
      const currentLineValue = tableData[rowIndex][code] // 当前行value
      const LastLineValue = tableData[rowIndex - 1] && tableData[rowIndex - 1][code] // 上一行value

      // 当前计算行 与上一行 数据相同时 上一行已经计算过合并行数量 则当前计算行的合并行数量为0
      if (rowIndex !== 0 && currentLineValue === LastLineValue && this.check(rowIndex, code, 'last')) {
        return 0
      }
      let rowspanCount = 0 // 合并行数默认为0
      tableData.some((item, index) => {
        if (index >= rowIndex && item[code] === currentLineValue) {
          rowspanCount++
        }
        // 避免相同code行不连续
        if (
          rowspanCount > 0 &&
          tableData[index + 1] &&
          currentLineValue !== tableData[index + 1][code]
        ) {
          return true
        }
        // 左侧 合并行的数据不同时 重新合并
        const flag = this.check(rowIndex, code, 'next')
        if (
          rowspanCount > 0 &&
          !flag
        ) {
          return true
        }
      })
      return rowspanCount
    },
    check(rowIndex, code , type) {
      const { tableData, rowSpanCodeList } = this
      const currentLine = tableData[rowIndex]
      const lastLine = type === 'last' ? tableData[rowIndex - 1] : tableData[rowIndex + 1]
      const lastRowSpanCode = rowSpanCodeList.slice(0, rowSpanCodeList.indexOf(code))
      let flag = true
      lastRowSpanCode.map(item => {
        if (lastLine && currentLine[item] !== lastLine[item]) {
          flag = false
        }
      })
      return flag
    },
    // 计算合并列的数量
    getColspanCount(rowIndex, code, columnSpanCodeList) {
      const { tableData } = this
      const currentColIndex = columnSpanCodeList.indexOf(code) // 当前列序号
      const currentColValue = tableData[rowIndex][code] // 当前列value
      const lastColValue =
      currentColIndex === 0
          ? ''
          : tableData[rowIndex][columnSpanCodeList[currentColIndex - 1]] // 上一列value
      if (currentColIndex !== 0 && currentColValue === lastColValue) {
        return 0
      }
      let colspanCount = 0
      columnSpanCodeList.some((code, index) => {
        if (index >= currentColIndex && tableData[rowIndex][code] === currentColValue) {
          colspanCount++
        }
        if (colspanCount > 0 && currentColValue !== tableData[rowIndex][code]) {
          return true
        }
      })

      return colspanCount
    },
  }
}
</script>
<style lang="scss" scoped>
.vTable-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .vTable-content {
    flex: 1;
    overflow: auto;
  }
  .vTable-title {
    ::v-deep .el-table__body-wrapper {
      display: none !important;
    }
  }
  .table-index {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border: 1px solid rgba(0,147,186,1);
    border-radius: 50%;
    color: rgba(0,147,186,1);
  }
  .table-index1 {
    border: 1px solid  rgba(186,0,0,1);
    color:  rgba(186,0,0,1);
  }
  .table-index2 {
    border: 1px solid  rgba(186,121,0,1);
    color:  rgba(186,121,0,1);
  }
  .table-index3 {
    border: 1px solid  rgba(0,186,128,1);
    color:  rgba(0,186,128,1);
  }
  ::v-deep .el-input__inner {
    background-color: transparent;
    color: #ffffff;
    border-color: rgba(64,145,195,0.24);
  }
}

.vTable-style-line {
  ::v-deep .el-table {
    background-color: transparent !important;
    color: #ffffff;
    &::before {
      background-color: transparent;
    }
    th {
      background-color: transparent !important;
      color: rgba(110,207,248,1);
    }
    th.el-table__cell.is-leaf {
      border-bottom: 1px solid rgba(64,145,195,0.24);
    }
    tr {
      background-color: transparent !important;
      &:hover > td {
        background-color:rgba(64,145,195,0.14) !important;
      }
    }
    td {
      border-bottom: 1px solid rgba(64,145,195,0.24);
    }
    .table-index {
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      border: 1px solid rgba(0,147,186,1);
      border-radius: 50%;
      color: rgba(0,147,186,1);
    }
    .table-index1 {
      border: 1px solid  rgba(186,0,0,1);
      color:  rgba(186,0,0,1);
    }
    .table-index2 {
      border: 1px solid  rgba(186,121,0,1);
      color:  rgba(186,121,0,1);
    }
    .table-index3 {
      border: 1px solid  rgba(0,186,128,1);
      color:  rgba(0,186,128,1);
    }
  }
}
.vTable-style-border {
  ::v-deep .el-table {
    background-color: transparent !important;
    color: #ffffff;
    border-color: rgba(64,145,195,0.24);
    &.el-table--border::after{
      background-color: transparent;
    }
    &::before {
      background-color: transparent;
    }
    th {
      // background-color: transparent !important;
      color: rgba(110,207,248,1);
      background-color:rgba(64,145,195,0.2) !important;
    }
    th.el-table__cell.is-leaf {
      border-color: rgba(64,145,195,0.24);
      border-bottom: none;
    }
    tr {
      background-color: transparent !important;
      &:hover > td {
        background-color:rgba(64,145,195,0.14) !important;
      }
    }
    td {
      border-color: rgba(64,145,195,0.24);
    }

  }
}

/* 滚动条轨道样式 */
::-webkit-scrollbar {
  // width: 4px; /* 设置滚动条宽度 */
  // height: 6px;
  width: 0;
  height: 0;
  background-color: transparent;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: transparent; /* 设置滑块背景颜色 */
  border-radius: none; /* 设置滑块圆角 */
}
/* 滚动条滑块hover状态样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(64,145,195,0.34); /* 设置滑块hover状态时的背景颜色 */
}
</style>
